module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/torino.d2f593b2f642ea286a5fa1667fdd838d.jpg";